import React, { useContext } from "react";
import { signInWithGoogle } from "../constants/firebase";
import { PopupContext } from "../containers/Popup";

export const Login = () => {
  const { chrome } = useContext(PopupContext);

  const signIn = () => {
    if (chrome) {
      chrome.runtime.sendMessage({ message: "get_auth_token" });
      chrome.runtime.onMessage.addListener(function (
        request,
        sender,
        sendResponse
      ) {
        if (request.message === "retrieved_auth_token") {
          console.log("TOKEN", request.token);
          signInWithGoogle(request.token);
        }
      });
    } else {
      signInWithGoogle();
    }
  };

  return (
    <>
      <div>
        <button
          type="button"
          className="py-3 px-8 w-full bg-blue-500 hover:bg-blue-400 focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg "
          onClick={signIn}
        >
          Log in
        </button>
      </div>
    </>
  );
};
